var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('StoreManagement')],1)],1),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('DepartmentManagement')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }